export const draftSenderPersonaPlaceholder = "NXEO";
export default {draftSenderPersonaPlaceholder};